<template>
  <div style="position:reative">
    <Spin size="large" fix v-if="spinShow"></Spin>
    <Row v-show="spinShow">
      <Col span="15" align="center">
      <span>{{ $t('loading') }}</span>
      </Col>
    </Row>

    <Form class="component-properties" ref="partForm" :model="formData" :rules="ruleValidate" label-position="top">
      <!-- name and chinese name field -->
      <Row :gutter="32">
        <Col span="12">
        <FormItem :label="$t('part.info.category')" prop="part_category_id">
          <PartCategorySelect :component-type="componentType" :categoryId.sync="formData.part_category_id"
            @change="handleChangePartCategory"></PartCategorySelect>
        </FormItem>
        </Col>
        <Col span="6">
        <FormItem :label="$t('part.info.chinese_name')" prop="chinese_name">
          <Input v-model="formData.chinese_name" :maxlength="100" show-word-limit></Input>
          <span class="suggest-value"
            v-if="formData.suggestion && formData.suggestion.chinese_name !== formData.chinese_name">{{
                formData.suggestion.chinese_name
            }}</span>
        </FormItem>
        </Col>
        <Col span="6">
        <FormItem :label="$t('part.info.english_name')" prop="name">
          <Input v-model="formData.name" :maxlength="200" show-word-limit></Input>
          <span class="suggest-value" v-if="formData.suggestion && formData.suggestion.name !== formData.name">{{
              formData.suggestion.name
          }}</span>
        </FormItem>
        </Col>
      </Row>
      <!-- name and chinese name field end -->
      <!-- mpn and brand field -->
      <Row :gutter="32">
        <Col span="12">
        <FormItem :label="$t('part.info.mpn')" prop="mpn">
          <Input v-model="formData.mpn" :maxlength="50" show-word-limit></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem :label="$t('part.info.brand')" prop="brand">
          <SelectCompany v-model="formData.brand" transfer></SelectCompany>
        </FormItem>
        </Col>
      </Row>
      <!-- mpn and brand field end -->
      <!-- specification field -->
      <Row :gutter="32">
        <Col span="20">
        <FormItem class="attr specification" :label="$t('part.info.specification')" prop="specification">
          <Input v-model="formData.specification" :maxlength="200" show-word-limit
            ></Input>
          <span class="suggest-value"
            v-if="formData.suggestion && formData.suggestion.specification !== formData.specification">{{
                formData.suggestion.specification
            }}</span>
          <span class="desc"
            v-if="specificationGeneratable || (isNew && formData.category && formData.category.specification_pattern)"
            style="font-size: 80%;">{{ formData.category ? formData.category.specification_pattern : '' }}
            <br>
            <i style="color: #2d8cf0">
              <Icon type="md-alert"></Icon>
              {{ $t('part.specification_alert') }}
            </i>
          </span>
        </FormItem>
        </Col>
        <!-- specification field end -->
        <!-- unit selecting field -->
        <Col span="4">
        <FormItem :label="$t('part.info.unit')" prop="unit">
          <Select v-model="formData.unit">
            <Option v-for="unit in units" :value="unit.value" :key="unit.value">{{ $t(unit.label) }}</Option>
          </Select>
        </FormItem>
        </Col>
      </Row>
      <!-- unit selecting field end-->
      <!-- description field -->
      <Row :gutter="32">
        <Col span="24">
        <FormItem :label="$t('part.info.description')" prop="description">
          <Input v-model="formData.description" type="textarea"></Input>
        </FormItem>
        </Col>
      </Row>
      <!-- description field -->
      <Row :gutter="32">
        <Col span="8">
        <!-- moderation state field -->
        <FormItem :label="$t('part.info.moderation')" prop="reviewed" required>
          <Select v-model="formData.reviewed" transfer>
            <Option v-for="item in moderationStates" :value="item.value" :key="item.value">
              {{ item.label }}
              <span style="float: right; font-size: 90%">{{ item.desc }}</span>
            </Option>
          </Select>
        </FormItem>
        <!-- moderation state field end -->
        </Col>
        <Col span="8">
        <!-- lifecylce status -->
        <FormItem :label="$t('part.info.lifecycle_status')" prop="lifecycle_status" required>
          <Select v-model="formData.lifecycle_status" transfer>
            <OptionGroup :label="$t('part.info.lifecycle_status_standard')">
              <Option v-for="item in lifecycleStatus.standard" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </OptionGroup>
            <OptionGroup :label="$t('part.info.lifecycle_status_custom')">
              <Option v-for="item in lifecycleStatus.custom" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </OptionGroup>
          </Select>
        </FormItem>
        <!-- lifecycle status field end -->
        </Col>
        <Col span="8">
        <!-- require quality exam field -->
        <FormItem :label="$t('part.info.require_quality_exam.field_name')" prop="require_quality_exam" required>
          <Select v-model="formData.require_quality_exam" transfer>
            <Option :value="0">{{ $t('part.info.require_quality_exam.no') }}</Option>
            <Option :value="1">{{ $t('part.info.require_quality_exam.yes') }}</Option>
          </Select>
        </FormItem>
        <!-- require quality exam field end -->
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="24" class="text-align-right" style="padding-top:24px;">
        <!--span changed-default="16"-->
        <Button data-test-id="part-change-log-link" v-if="!isNew" type="text" @click="showChangeLog = true">{{
            $t('part.component_change_histories')
        }}</Button>&nbsp;
        <Button data-test-id="save-part-btn" type="primary" @click="handleSubmit(false)" :loading="saving">{{ $t('save')
        }}</Button>
        </Col>
      </Row>
    </Form>

    <Modal id="component-change-log" v-model="showChangeLog" :title="$t('part.component_change_histories')" width="80%"
      mask>
      <PartAuditChangeLog v-if="!isNew && manufacturerPart" :component-type="componentType" :id="manufacturerPart.id">
      </PartAuditChangeLog>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import PartAuditChangeLog from "../part-audit-changelog"
import SelectCompany from "@/view/companies/components/selectCompany"
import PartCategorySelect from "../part-category-select"
import Validations from "../validation"
import Message from "@/components/message"

export default {
  name: "PartForm",
  components: {
    Message,
    PartAuditChangeLog,
    PartCategorySelect,
    SelectCompany
  },
  props: {
    manufacturerPartId: {
      type: [String, Number],
      required: false
    },
    manufacturerPart: {
      type: Object,
      required: false
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      spinShow: false,
      formData: {
        unit: ''
      },
      ruleValidate: Validations.part_properties,
      saving: false,
      showChangeLog: false,
      moderationStates: [
        { value: 0, label: 'Draft', desc: 'May have problem to be referenced.' },
        { value: 1, label: 'Reviewed', desc: 'OK to be referenced.' },
        { value: -1, label: 'Invalid', desc: 'Stop using it immediately.' }
      ],
      lifecycleStatus: {
        standard: [
          { value: 'active', label: 'Active' },
          { value: 'nrnd', label: 'Not recommended for new designs (NRND)' },
          { value: 'eol', label: 'End of life (EOL)' }
        ],
        custom: [
          { value: 's0', label: 'S0 - Concept/Design' },
          { value: 's1', label: 'S1 - Prototyping (Functional testing)' },
          { value: 's2', label: 'S2 - Prototyping (Manufacturable testing)' },
          { value: 's3', label: 'S3 - NPI' },
          { value: 's4', label: 'S4 - Pilot run' },
          { value: 's5', label: 'S5 - Volume production' },
          { value: 's6', label: 'S6 - SCM' }
        ]
      },
      units: [
        { value: 'pcs', label: "part.info.units.pcs" },
        { value: 'batch', label: "part.info.units.batch" },
        { value: 'unit', label: "part.info.units.unit" },
        { value: 'set', label: "part.info.units.set" },
        { value: 'suit', label: "part.info.units.suit" },
        { value: 'roll', label: "part.info.units.roll" },
        { value: 'kg', label: "part.info.units.kg" }
      ],
      editable: true,
      componentType: 'electronic-part'
    }
  },
  computed: {
    specificationGeneratable: function () {
      return !!(this.manufacturerPart && this.manufacturerPart.category && this.manufacturerPart.category.specification_pattern)
    }
  },
  mounted() {
    this.getPartClassesTree()
  },
  methods: {
    ...mapActions([
      "updateElectronicPart",
      "createElectronicPart",
      "getPartClassesTree"
    ]),
    setEditableMode(value) {
      this.editable = value.reviewed !== 1
    },
    refreshPartClassesTree() {
      this.getPartClassesTree({ refresh: true })
    },
    handleSubmit(close) {
      if (!this.formData.category) {
        this.formData.part_category_id = null
      }
      this.$refs.partForm.validate((valid) => {
        if (valid) {
          this.saving = true
          this.save(close)
        }
      })
    },
    save(close) {
      this.saving = true
      if (this.isNew) {
        this.createElectronicPart(this.formData)
          .then((resp) => {
            this.$Message.info(this.$t("message.success_on_saving"))
            this.$emit("on-saved", resp, close)
          })
          .finally(() => {
            this.saving = false
          })
      } else {
        this.updateElectronicPart({ id: this.$route.params.partId, data: this.formData })
          .then((resp) => {
            this.$Message.info(this.$t("message.success_on_saving"))
            this.$emit("on-saved", resp, close)
          })
          .finally(() => {
            this.saving = false
          })
      }
    },
    updateForm(manufacturerPart) {
      // Init values
      this.formData = _.cloneDeep(manufacturerPart)

      this.newPartNumberPrefix = null
      this.showChangePartNumberForm = false

      this.setEditableMode(manufacturerPart)

      if (_.isEmpty(this.formData.unit)) {
        this.formData.unit = 'pcs'
      }
      if (manufacturerPart.suggestion && _.isEmpty(this.formData.name)) {
        this.formData.name = manufacturerPart.suggestion.name
      }
      if (
        manufacturerPart.suggestion &&
        _.isEmpty(this.formData.chinese_name)
      ) {
        this.formData.chinese_name = manufacturerPart.suggestion.chinese_name
      }
      if (
        manufacturerPart.specification &&
        _.isEmpty(this.formData.specification)
      ) {
        this.formData.specification = manufacturerPart.suggestion.specification
      }
      if (manufacturerPart.category) {
        this.newPartNumberPrefix = manufacturerPart.category.class_number
      }
      this.saving = false

      this.$emit('update:formData', this.formData)
    },
    handleChangePartCategory(category) {
      if (category) {
        let classNumber = category.class_number
        if (
          _.startsWith(classNumber, "KB") ||
          _.startsWith(classNumber, "KH")
        ) {
          classNumber = classNumber + "049"
        } else if (_.startsWith(classNumber, "J")) {
          classNumber = classNumber + "04"
        } else if (_.startsWith(classNumber, "ME")) {
          classNumber = _.padEnd(classNumber, 8, "0")
        }
        this.newPartNumberPrefix = classNumber
      } else {
        this.newPartNumberPrefix = null
      }
      this.formData.category = category
    }
  },
  watch: {
    manufacturerPart: {
      deep: true,
      handler() {
        this.updateForm(this.manufacturerPart)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.associated-parts {
  line-height: 32px;
}

.suggest-value {
  line-height: 15px;
  font-style: italic;
  font-size: small;
  color: rgb(248, 120, 0);
  display: block;
}

.desc {
  line-height: 15px;
  font-style: italic;
  font-size: small;
  color: #666;
  display: block;
}

.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 100;
}

#component-change-log {
  .ivu-modal-mask {
    z-index: 5601 !important;
  }

  .ivu-modal-wrap {
    z-index: 5602 !important;
  }
}
</style>
